export default 'https://vue-moire.skillbox.cc';
